export default __webpack_public_path__ + "static/media/step - 10.65d3d048.jpeg";